// src/api/scraperService.js
import { api } from './client';

const TRIGGER_API_KEY = process.env.REACT_APP_TRIGGER_API_KEY;  // your secret key

// Fetch all scraper configurations
export function getConfigs() {
  return api.get('/api/scrapers/config').then(res => res.data);
}

// Create a new scraper target
export function createConfig(cfg) {
  return api.post('/api/scrapers/config', cfg).then(res => res.data);
}

// Update an existing config by ID
export function updateConfig(id, data) {
  return api.put(`/api/scrapers/config/${id}`, data).then(res => res.data);
}

// Disable (soft-delete) a config
export function deleteConfig(id) {
  return api.delete(`/api/scrapers/config/${id}`).then(res => res.data);
}

// Trigger the scraper run (requires API key header)
export function runScraper() {
  return api.post(
    '/api/scrapers/run',
    {},
    { headers: { 'X-API-Key': TRIGGER_API_KEY } }
  ).then(res => res.data);
}

// (Optional) Fetch scrape history for a given SKU
export function getHistory(sku) {
  return api
    .get(`/api/scrapers/history`, { params: { sku } })
    .then(res => res.data);
}

export function testConfig(id) {
  return api
    .post(`/api/scrapers/config/${id}/test`)
    .then(res => res.data);
}

// Browser EventSource cannot set Authorization headers. Before opening an
// SSE connection to /api/scrapers/config/run, fetch a short-lived HMAC
// token here (15-min expiry, handshake-only validation) and append it as
// ?token=<...>. Mirrors the notify SSE pattern.
export function getScraperSSEToken() {
  return api.get('/api/scrapers/sse-token').then(res => res.data.token);
}

export function aiSuggest(payload) {
  return api.post('/api/scrapers/ai/helpers', payload)
            .then(res => res.data);
}